import './SelectedEntries.scss';
import './scrollbar.scss';
import type { Entry } from './types';
import { Entries } from './Entries';
import { _ } from '../../Lang.class.js';

type SelectedEntriesCallbacks = {
    onClickEntry: (entry: Entry) => void;
};

export class SelectedEntries extends Entries {
    private readonly root: HTMLDivElement;
    private readonly callbacks: SelectedEntriesCallbacks;
    private currentSearchString: string = '';

    constructor(root: HTMLDivElement, callbacks: SelectedEntriesCallbacks) {
        super();
        this.root = root;
        this.callbacks = callbacks;
        this.render();
    }

    public getCount(): number {
        return this.entries.length;
    }

    private render(): void {
        this.root.innerHTML = this.getHTML();
    }

    public populate(entries: Entry[]): void {
        super.populate(entries);
        this.redraw();
    }

    public redraw(): void {
        const entriesList = this.root.querySelector('.selected-entries-list');
        if (!entriesList) return;

        entriesList.innerHTML = '';
        this.entries.forEach(entry => {
            const entryElement = document.createElement('div') as HTMLDivElement;
            const entryName = _(entry.name);
            entryElement.classList.add('entry');
            entryElement.dataset.id = entry.id.toString();
            entryElement.innerHTML =
                `
            <div class="entry-container">
                <div class="entry-name">` +
                (entryName.charAt(0).toLocaleUpperCase() + entryName.slice(1)) +
                `</div>
                <div class="entry-remove"></div>
            </div>`;
            entriesList.appendChild(entryElement);

            // Remove entry on click
            entryElement.addEventListener('click', () => {
                this.callbacks.onClickEntry(entry);
            });
        });

        // Re-apply the current search filter after redraw
        if (this.currentSearchString) {
            this.filter(this.currentSearchString);
        }
    }

    public filter(searchString: string): void {
        // Store the current search string
        this.currentSearchString = searchString;

        // First, ensure we have entries rendered
        const entries = this.root.querySelectorAll('.entry');

        let visibleCount = 0;
        entries.forEach(entry => {
            const entryNameElement = entry.querySelector('.entry-name');
            if (
                searchString !== '' &&
                entryNameElement &&
                entryNameElement.innerHTML.toLowerCase().indexOf(searchString.toLowerCase()) === -1
            ) {
                entry.classList.add('hidden');
            } else {
                entry.classList.remove('hidden');
                visibleCount++;
            }
        });

        // Show "no results" message if searching and no visible entries
        if (searchString !== '' && visibleCount === 0 && this.entries.length > 0) {
            this.showNoResults();
        } else {
            this.hideMessages();
        }
    }

    public showNoResults(): void {
        const entriesListElement = this.root.querySelector('.selected-entries-list');
        if (!entriesListElement) return;

        // Check if message already exists
        let messageElement = entriesListElement.querySelector('.selected-entries-message');
        if (!messageElement) {
            messageElement = document.createElement('div');
            messageElement.classList.add('selected-entries-message', 'no-results');
            messageElement.textContent = 'Nie znaleziono elementów dla podanej frazy';
            entriesListElement.appendChild(messageElement);
        }
    }

    public hideMessages(): void {
        const entriesListElement = this.root.querySelector('.selected-entries-list');
        if (!entriesListElement) return;

        const messageElement = entriesListElement.querySelector('.selected-entries-message');
        if (messageElement) {
            messageElement.remove();
        }
    }

    private getHTML(): string {
        return `
            <div class="selected-entries-list"></div>
        `;
    }
}
